import { IPromise, IRootScopeService } from "angular";
import { LinkService } from "@gtmhub/links";
import { OkrEvents } from "@gtmhub/okrs";
import { GoalLink, LinksDTO } from "@webapp/links/models/links.models";

export class GoalLinkService {
  private okrEvents: OkrEvents;

  public static $inject = ["$rootScope", "LinkService"];

  constructor($rootScope: IRootScopeService, private linkService: LinkService) {
    this.okrEvents = new OkrEvents($rootScope);
  }

  public link(sourceId: string, linkType: GoalLink, targetId: string): IPromise<void> {
    return this.linkService.link({ sourceType: "goals", sourceId, linkType, targetType: "goals", targetId }).then(() => {
      const link: LinksDTO<GoalLink> = { sourceId, targetId, linkType, targetType: "goals", sourceType: "goals" };
      this.okrEvents.broadcastGoalsChanged("goalLinked", { goalId: sourceId, link });
    });
  }

  public unlink(sourceId: string, linkType: GoalLink, targetId: string): IPromise<void> {
    return this.linkService.unlink({ sourceType: "goals", sourceId, linkType, targetType: "goals", targetId }).then(() => {
      const link: LinksDTO<GoalLink> = { sourceId, targetId, linkType, targetType: "goals", sourceType: "goals" };
      this.okrEvents.broadcastGoalsChanged("goalUnlinked", { goalId: sourceId, link });
    });
  }
}
